import React, { memo } from 'react';

const StartBriefIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="7.448783634345091e-8, -7.448783634345091e-8, 62, 82"
  >
    <path d="M41.89 12H20.11A5.113 5.113 0 0 1 15 6.89V5.11A5.113 5.113 0 0 1 20.11 0H41.9A5.111 5.111 0 0 1 47 5.11V6.9a5.111 5.111 0 0 1-5.11 5.1zM20.11 2A3.107 3.107 0 0 0 17 5.11V6.9a3.1 3.1 0 0 0 3.11 3.1H41.9A3.1 3.1 0 0 0 45 6.89V5.11A3.107 3.107 0 0 0 41.89 2z" />
    <path d="M56.89 82H5.11A5.113 5.113 0 0 1 0 76.89V10.11A5.113 5.113 0 0 1 5.11 5H16v2H5.11A3.107 3.107 0 0 0 2 10.11V76.9A3.1 3.1 0 0 0 5.11 80H56.9a3.113 3.113 0 0 0 3.11-3.11V10.11A3.122 3.122 0 0 0 56.89 7H46V5h10.89A5.113 5.113 0 0 1 62 10.11V76.9a5.111 5.111 0 0 1-5.11 5.1z" />
    <path d="M51.55 23.01h-40a1 1 0 0 1 0-2h40a1 1 0 0 1 0 2z" />
    <path d="M51.55 33.76h-40a1 1 0 0 1 0-2h40a1 1 0 0 1 0 2z" />
    <path d="M51.55 44.5h-40a1 1 0 1 1 0-2h40a1 1 0 0 1 0 2z" />
    <path d="M51.55 55.24h-40a1 1 0 1 1 0-2h40a1 1 0 0 1 0 2z" />
    <path d="M31.55 65.99h-20a1 1 0 1 1 0-2h20a1 1 0 0 1 0 2z" />
  </svg>
);

export default memo(StartBriefIcon);
